import {
  FormOutlined,
  AudioOutlined,
  GlobalOutlined,
  PhoneOutlined,
  VideoCameraOutlined,
} from "@ant-design/icons";

export const FEEDBACK_FORMAT = {
  TEXT: "text",
  VOICE: "voice",
  VIDEO: "video",
};

export const FORMAT_OPTIONS = [
  {
    key: FEEDBACK_FORMAT.TEXT,
    icon: FormOutlined,
    titleKey: "feedbackCapture.format_text_title",
    descKey: "feedbackCapture.format_text_desc",
    comingSoon: false,
  },
  {
    key: FEEDBACK_FORMAT.VOICE,
    icon: AudioOutlined,
    titleKey: "feedbackCapture.format_voice_title",
    descKey: "feedbackCapture.format_voice_desc",
    comingSoon: false,
  },
  {
    key: FEEDBACK_FORMAT.VIDEO,
    icon: VideoCameraOutlined,
    titleKey: "feedbackCapture.format_video_title",
    descKey: "feedbackCapture.format_video_desc",
    comingSoon: true,
    waitlistFeature: "video_feedback",
  },
];

// How a voice survey reaches people: the AI agent calls them (outbound), or they talk to it
// on a site or in an app (inbound; today the voice capture widget).
export const VOICE_DELIVERY = {
  CALL: "call",
  WIDGET: "widget",
};

export const VOICE_DELIVERY_OPTIONS = [
  {
    key: VOICE_DELIVERY.CALL,
    icon: PhoneOutlined,
    titleKey: "feedbackCapture.voice_delivery_call_title",
    descKey: "feedbackCapture.voice_delivery_call_desc",
    tagKey: "feedbackCapture.voice_delivery_outbound",
  },
  {
    key: VOICE_DELIVERY.WIDGET,
    icon: GlobalOutlined,
    titleKey: "feedbackCapture.voice_delivery_widget_title",
    descKey: "feedbackCapture.voice_delivery_widget_desc",
    tagKey: "feedbackCapture.voice_delivery_inbound",
  },
];

export const FORMAT_META = {
  [FEEDBACK_FORMAT.TEXT]: {
    labelKey: "feedbackCapture.format_badge_text",
    color: "blue",
    icon: FormOutlined,
  },
  [FEEDBACK_FORMAT.VOICE]: {
    labelKey: "feedbackCapture.format_badge_voice",
    color: "purple",
    icon: AudioOutlined,
  },
  [FEEDBACK_FORMAT.VIDEO]: {
    labelKey: "feedbackCapture.format_badge_video",
    color: "magenta",
    icon: VideoCameraOutlined,
  },
};

export const STATUS_FILTERS = [
  { key: "all", labelKey: "surveyManagement.status_all" },
  { key: "draft", labelKey: "surveyManagement.status_draft" },
  { key: "active", labelKey: "surveyManagement.status_active" },
  { key: "closed", labelKey: "surveyManagement.status_closed" },
];

export const STATUS_META = {
  draft: { labelKey: "surveyManagement.status_draft", color: "default" },
  active: { labelKey: "surveyManagement.status_active", color: "green" },
  closed: { labelKey: "surveyManagement.status_closed", color: "red" },
};
